import React from "react"
import { Route, Routes, BrowserRouter } from "react-router-dom"

import WorkspaceLayout from "~/layouts/Workspace"
import Dashboard from "~/views/Dashboard"

import ClientList from "~/views/ClientList"
import BookingList from "~/views/BookingList"
import BookingCreated from "~/views/BookingCreated"
import NewBooking from "~/views/NewBooking"
import EditBooking from "~/views/EditBooking"
import AreaList from "~/views/AreaList"
import NewArea from "~/views/NewArea"
import EditArea from "~/views/EditArea"
import SalesReport from "~/views/SalesReport"
import ReportsView from "~/views/ReportsView"
import { AreaView, BookingView, ClientView, SponsorshipView } from "~/views"
import VenueSettings from "~/views/VenueSettings"
import PacksList from "~/views/PacksList"
import LineItemsList from "~/views/LineItemsList"
import NewPack from "~/views/NewPack"
import EditPack from "~/views/EditPack"
import PackView from "~/views/PackView"
import NewLineItem from "~/views/NewLineItem"
import EditLineItem from "~/views/EditLineItem"
import LineItemView from "~/views/LineItemView"
import CategoriesList from "~/views/CategoriesList"
import NewCategory from "~/views/NewCategory"
import EditCategory from "~/views/EditCategory"
import CategoryView from "~/views/CategoryView"
import MenusList from "~/views/MenusList"
import NewMenu from "~/views/NewMenu"
import EditMenu from "~/views/EditMenu"
import MenuView from "~/views/MenuView"
import SponsorshipsList from "~/views/SponsorshipsList"
import EditSponsorship from "~/views/Sponsorship/EditSponsorship"

import PaymentList from "~/views/Workspace/Payments/PaymentList"
import PaymentView from "~/views/Workspace/Payments/PaymentView"

import getAppConfig from "~/utils/getAppConfig"

const { venueSlug } = getAppConfig()

const Router = () => {
  return (
    <BrowserRouter basename={`workspace/${venueSlug}`}>
      <Routes>
        <Route path="/" element={<WorkspaceLayout />}>
          <Route path="/" index element={<Dashboard />} />
          <Route path="/clients" element={<ClientList />} />
          <Route path="/clients/:id" element={<ClientView />} />
          <Route path="/bookings" element={<BookingList />} />
          <Route path="/bookings/new" element={<NewBooking />} />
          <Route path="/bookings/created" element={<BookingCreated />} />
          <Route path="/bookings/:id" element={<BookingView />} />
          <Route path="/bookings/:id/edit" element={<EditBooking />} />
          <Route path="/areas" element={<AreaList />} />
          <Route path="/areas/new" element={<NewArea />} />
          <Route path="/areas/:id" element={<AreaView />} />
          <Route path="/areas/:id/edit" element={<EditArea />} />
          <Route path="/payments" element={<PaymentList />} />
          <Route path="/payments/:id" element={<PaymentView />} />
          <Route path="/insights/sales" element={<SalesReport />} />
          <Route path="/reports" element={<ReportsView />} />
          <Route path="/settings/venue" element={<VenueSettings />} />
          <Route path="/packs" element={<PacksList />} />
          <Route path="/packs/new" element={<NewPack />} />
          <Route path="/packs/:id" element={<PackView />} />
          <Route path="/packs/:id/edit" element={<EditPack />} />
          <Route path="/menus" element={<MenusList />} />
          <Route path="/menus/new" element={<NewMenu />} />
          <Route path="/menus/:id" element={<MenuView />} />
          <Route path="/menus/:id/edit" element={<EditMenu />} />
          <Route path="/categories" element={<CategoriesList />} />
          <Route path="/categories/new" element={<NewCategory />} />
          <Route path="/categories/:id" element={<CategoryView />} />
          <Route path="/categories/:id/edit" element={<EditCategory />} />
          <Route path="/line-items" element={<LineItemsList />} />
          <Route path="/line-items/new" element={<NewLineItem />} />
          <Route path="/line-items/:id" element={<LineItemView />} />
          <Route path="/line-items/:id/edit" element={<EditLineItem />} />
          <Route path="/sponsorship" element={<SponsorshipsList />} />
          <Route path="/sponsorship/:id" element={<SponsorshipView />} />
          <Route path="/sponsorship/:id/edit" element={<EditSponsorship />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
